import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { TOAST } from "libs/utils/constants";

interface ToastState {
  showToast: boolean;
  message: string;
  type: string;
}

export const openToast = createAsyncThunk(
  "toast/open",
  async (
    { message, type = "fail" }: { message: string; type?: string },
    thunkAPI
  ) => {
    setTimeout(() => {
      thunkAPI.dispatch(closeToast());
    }, TOAST.TOAST_LENGTH_SHORT);
    return { showToast: true, message, type };
  }
);

const initialState = {
  showToast: false,
  message: null,
} as ToastState;

export const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    closeToast: (state) => {
      state.showToast = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(openToast.fulfilled, (state, action) => {
      state.showToast = action.payload?.showToast;
      state.message = action.payload?.message;
      state.type = action.payload?.type;
    });
  },
});

export const { closeToast } = toastSlice.actions;
export default toastSlice.reducer;
